import React from "react";

import { SingleJob, SingleCompany } from "interfaces/api/apiInterfaces";

import styles from "./JobIndividualSidebar.module.scss";

export const SuggestedSearchesSidebarModule = (props: {
    job: SingleJob, company: SingleCompany, museWebHost: string
}) => {
    const {
        job,
        company,
        museWebHost,
    } = props;
    let suggestedSearchLinks = [
        {
            suggestedSearchType: "level",
            href: `${museWebHost}/search/level/${job?.levels[0]?.value}`,
            displayText: `${job?.levels[0]?.display} jobs`,
            active: !!job?.levels?.length
        },
        {
            suggestedSearchType: "company",
            href: `${museWebHost}/hiring/company/${company?.short_name}`,
            displayText: `${company?.name} jobs`,
            active: true
        },
        {
            suggestedSearchType: "alljobs",
            href: `${museWebHost}/hiring`,
            displayText: "All jobs",
            active: true
        },
    ];
    const category = job?.categories[0];
    if (category?.value.toLowerCase() !== "unknown") {
        suggestedSearchLinks = [
            {
                suggestedSearchType: "category",
                href: `${museWebHost}/hiring/category/${category?.code}`,
                displayText: `${category?.value} jobs`,
                active: !!job?.categories?.length
            },
            ...suggestedSearchLinks
        ];
    }

    return (
        <div className={styles.suggestedSearchesModule}>
            <h2>Suggested Searches</h2>
            <ul>
                { suggestedSearchLinks.map((searchLink, index) => searchLink.active ? (
                    <li key={`suggested-search-link-${searchLink.suggestedSearchType}`}>
                        <a target="_blank" href={searchLink.href}>{searchLink.displayText}</a>
                    </li>
                ) : null) }
            </ul>
        </div>
    );
};
